export enum Parameters {
  employerId = 'employerId',
  iraUserId = 'iraUserId',
  independentIraUserId = 'independentIraUserId',
  contributionId = 'contributionId',
  size = 'size',
  page = 'page',
  order = 'order',
  dateRange = 'dateRange',
  status = 'status',
  userProfileType = 'userProfileType',
  custodianType = 'custodianType',
  displaySepIra = 'displaySepIra',
  onlyFunded = 'onlyFunded',
  accountClosed = 'accountClosed',
  search = 'search',

  accessKey = 'accessKey',
}
